import type { Translations } from "../types";

const ru: Translations = {
  "meta.title": "Карта кликов по странам",
  "meta.description":
    "Интерактивная карта мира: бесплатные клики по странам, а также платная поддержка через Stripe, PayPal и Buy Me a Coffee.",

  "app.title": "Карта кликов по странам",

  "map.intro":
    "Нажмите на страну на карте, чтобы отдать ей бесплатный голос, или отправьте ей финансовую поддержку - и то и другое учитывается в общем рейтинге ниже. Карта отражает только поддержку внутри этого приложения, а не реальное национальное богатство или ВВП.",
  "map.verifying": "Проверка …",
  "map.confirmNotRobot": "Прежде чем добавлять бесплатные клики, быстро подтвердите, что вы не робот:",
  "map.tryAgain": "Попробовать снова",
  "map.registeringClick": "Регистрация клика …",
  "map.selectedCountry": "Выбранная страна: {name}.",
  "map.selectFirstFeedback": "Страна выбрана. Чтобы добавить бесплатный клик, сначала подтвердите ниже, что вы не робот.",
  "map.verificationExpired": "Срок проверки истёк - подтвердите ещё раз, что вы не робот.",
  "map.slowDown": "Помедленнее - подождите немного перед следующим кликом.",
  "map.clickFailed": "Не удалось зарегистрировать клик. Попробуйте ещё раз.",
  "map.clickErrorGeneric": "Ошибка при регистрации клика.",
  "map.leaderboardHeading": "Рейтинг стран",
  "map.emptySelection": "Выберите страну на карте, чтобы кликнуть по ней или поддержать её.",
  "map.loadingData": "Загрузка данных …",

  "worldmap.loadError": "Не удалось загрузить карту.",
  "worldmap.resetZoom": "Сбросить масштаб",
  "worldmap.resetButton": "⤾ Сбросить",
  "worldmap.loadingMap": "Загрузка карты …",
  "worldmap.unknownCountry": "Неизвестно",
  "worldmap.ariaClicks": "{name}: {clicks} кликов",
  "worldmap.tooltipClicks": "{clicks} кликов",

  "legend.fewer": "Меньше кликов",
  "legend.more": "Больше кликов",

  "list.empty": "Пока нет кликов. Будьте первым!",
  "list.ariaLabel": "Рейтинг стран по кликам",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY не задан - см. README для настройки.",
  "human.verificationFailedGeneric": "Проверка не пройдена.",
  "human.networkError":
    "Не удалось связаться с сервисом проверки (ошибка сети) - проверьте VITE_SUPABASE_URL, что verify-human развёрнут, и ALLOWED_ORIGIN; см. README/NAVODILA.",
  "human.verificationFailedRetry": "Проверка не пройдена, попробуйте снова.",

  "provider.stripe": "💳 Карта (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "Выбранная страна",
  "panel.currentlyRanked": "Сейчас на месте #{rank}",
  "panel.shareCopied": "Скопировано ✓",
  "panel.shareShared": "Отправлено ✓",
  "panel.shareButton": "🔗 Поделиться",

  "panel.tableClicks": "Клики",
  "panel.tableFree": "Бесплатные",
  "panel.tablePaid": "Платные",
  "panel.rowAllTime": "За всё время",
  "panel.rowThisYear": "За этот год",
  "panel.rowThisWeek": "За эту неделю",
  "panel.rowToday": "Сегодня",

  "panel.totalCombined": "Итого:",
  "panel.totalSupport": "Всего поддержки:",

  "panel.paymentMethod": "Способ оплаты",
  "panel.noPaymentMethod": "В настоящее время нет доступных способов оплаты.",
  "panel.supportAmount": "Сумма поддержки (EUR)",
  "panel.amountRange": "Сумма должна быть от {min} до {max}.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "Оценочное количество платных кликов:",
  "panel.ratioInfo":
    "Соотношение: {a} = {b} кликов (например, {c} = {d} кликов). Это лишь приблизительная оценка до оплаты - итоговое количество кликов всегда рассчитывается и подтверждается сервером на основе фактически подтверждённого платежа.",
  "panel.preparing": "Подготовка …",
  "panel.continueWith": "Продолжить с {provider}",
  "panel.choosePaymentMethod": "Выберите способ оплаты",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME не задан - см. README для настройки.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID не задан - см. README для настройки.",

  "panel.paypalAmountInfo": "Сумма: {amount} (примерно {clicks} кликов). Завершите оплату с помощью кнопки PayPal ниже.",
  "panel.back": "← Назад",

  "panel.bmcWarningTitle": "⚠️ Прежде чем перейти в BuyMeCoffee:",
  "panel.bmcWarningBody":
    "Вставьте код ниже в поле сообщения/примечания при оформлении платежа — это единственный способ узнать, какую страну вы поддерживаете. Без кода мы не сможем привязать платёж ни к одной стране.",
  "panel.copy": "Копировать",
  "panel.copied": "Скопировано ✓",
  "panel.suggestedAmount": "Рекомендуемая сумма:",
  "panel.bmcAmountNote":
    "(примерно {clicks} кликов). К сожалению, BuyMeCoffee не поддерживает передачу суммы по ссылке — введите или выберите её самостоятельно на их сайте. Фактическое количество кликов всегда рассчитывается на основе суммы, которую вы действительно отправите на BuyMeCoffee, а не по этой оценке.",
  "panel.openBmc": "Открыть BuyMeCoffee и продолжить →",
  "panel.waitingProvider": "Ожидание подтверждения оплаты от платёжного провайдера …",
  "panel.waitingConfirmation": "Ожидание подтверждения оплаты …",
  "panel.timedOut":
    "Время ожидания проверки истекло. Если вы завершили оплату, карта обновится, как только сервер получит подтверждение - иногда это может занять немного больше времени.",
  "panel.checkAgain": "Проверить снова",

  "panel.cancelled": "Платёж был отменён или не прошёл. Карта не изменилась.",
  "panel.tryAgain": "Попробовать снова",

  "panel.confirmed": "✅ Поддержка подтверждена!",
  "panel.confirmedBody": "{country} получила {clicks} платных кликов на сумму {amount}.",

  "panel.errorPreparingSupport": "Ошибка при подготовке вашей поддержки.",
  "panel.errorPreparingPayment": "Ошибка при подготовке платежа.",
  "panel.errorConfirmingPayment": "Ошибка при подтверждении платежа.",
  "panel.errorPayingPaypal": "Ошибка при оплате через PayPal.",

  "share.unranked": "{flag}{country} нуждается в вашей поддержке на карте мира!\nПомогите ей подняться в рейтинге 👇",
  "share.rank1": "{flag}{country} сейчас на #1!\nПомогите нам остаться на вершине 👇",
  "share.rankN": "{flag}{country} сейчас на месте #{rank}!\nПомогите нам добраться до #1 👇",

  "language.switcherLabel": "Язык",
};

export default ru;
